import { Component, Vue } from 'vue-property-decorator';
import { getContributionLevelFromDrops } from '@/helpers';
import { UserInLegendBoardUI, TableHeaderColumns, UserDTO } from '@/models';
import { fetchUsersInLegend } from '@/services';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';
import UserInformation from '@/components/common/user-information/UserInformation.vue';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';

@Component({
  components: {
    UserInformation,
    ContributionLevelIcon,
    InlineLoader
  }
})
export default class LeaderBoard extends Vue {
  private currentUser = {} as UserDTO;
  private usersInLegend = [] as UserInLegendBoardUI[];
  private legendLoading = true;
  private TABLE_TYPE = {
    TWO_LATEST_PERIODS: 'twoLatestPeriods',
    ALL_TIME: 'allTime'
  };
  private isTwoLatestPeriods = true;

  private headers: TableHeaderColumns = [
    {
      text: 'ranking',
      value: 'ranking',
      cellClass: 'leader-board__from-top4-cell--top'
    },
    {
      text: 'ContributionLevel',
      value: 'contributionLevel',
      cellClass: 'leader-board__from-top4-cell--contribution-level'
    },
    {
      text: 'User',
      value: 'user',
      cellClass: 'leader-board__from-top4-cell--user'
    },
    {
      text: 'accumulatedDrops',
      value: 'accumulatedDrops',
      align: 'right'
    }
  ];

  get usersInTop3(): UserInLegendBoardUI[] {
    let usersTop3 = [] as UserInLegendBoardUI[];
    if (this.usersInLegend.length > 0) {
      const medals = ['gold', 'silver', 'bronze'];
      usersTop3 = this.usersInLegend.slice(0, 3).map((user, index) => {
        user.medal = medals[index];
        return user;
      });
      // swap array to [1,0,2]
      if (usersTop3.length > 1) {
        [usersTop3[0], usersTop3[1]] = [usersTop3[1], usersTop3[0]];
      }
    }
    return usersTop3;
  }

  get usersFromTop4(): UserInLegendBoardUI[] {
    return this.usersInLegend.slice(3);
  }

  get isEmptyDataSource(): boolean {
    return this.usersInLegend.length === 0;
  }

  async onChangeTableType(type: string): Promise<void> {
    this.legendLoading = true;
    this.isTwoLatestPeriods = type === this.TABLE_TYPE.TWO_LATEST_PERIODS;
    await this.fetchTopUserInLegend(this.isTwoLatestPeriods);
    this.legendLoading = false;
  }

  isCurrentUser(userId: number): boolean {
    return this.currentUser.id === userId;
  }

  getCurrentUserClass(user: UserDTO): string {
    return this.isCurrentUser(user.id) ? 'leader-board__from-top4-current-user' : '';
  }

  private buildUsersInLegend(userList: UserInLegendBoardUI[]) {
    if (userList) {
      this.usersInLegend = userList.map((user: UserInLegendBoardUI) => {
        return { ...user, contributionLevel: getContributionLevelFromDrops(user.accumulatedDrops) };
      });
    }
  }

  async fetchTopUserInLegend(isTwoLatestPeriods: boolean): Promise<void> {
    const { data } = await fetchUsersInLegend(isTwoLatestPeriods);
    this.buildUsersInLegend(data);
  }

  async created(): Promise<void> {
    this.currentUser = this.$store.getters['app/currentUser']?.id
      ? this.$store.getters['app/currentUser']
      : await this.$store.dispatch('app/fetchCurrentUser');
    await this.fetchTopUserInLegend(true);
    this.legendLoading = false;
  }
}
